import { css } from 'styled-components';
export const breakpointValues = {
  hd: 1920,
  mon569: 1700,
  sd: 1366,
  sdMac: 1280,
  cs: 1190,
  tablet: 1024,
  mon569Height: 900,
  tabletPortrait: 800,
  phoneLarge: 680,
  phone: 500,
  featureContentModal: 960
};
const breakpointScreens = Object.keys(breakpointValues);
export const minWidthBreakpoint = breakpointScreens.reduce((acc, label) => {
  acc[label] = (template, ...args) => css(["@media (min-width:", "em){", "}"], (breakpointValues[label] + 1) / 16, css(template, ...args));
  return acc;
}, {});
export const minHeightBreakpoint = breakpointScreens.reduce((acc, label) => {
  acc[label] = (template, ...args) => css(["@media (min-height:", "em){", "}"], breakpointValues[label] / 16, css(template, ...args));
  return acc;
}, {});
export const maxHeightBreakpoint = breakpointScreens.reduce((acc, label) => {
  acc[label] = (template, ...args) => css(["@media (max-height:", "em){", "}"], breakpointValues[label] / 16, css(template, ...args));
  return acc;
}, {});
export default breakpointScreens.reduce((acc, label) => {
  acc[label] = (template, ...args) => css(["@media (max-width:", "em){", "}"], breakpointValues[label] / 16, css(template, ...args));
  return acc;
}, {});